var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 20v-2.858h26.877V20zm0-8.571V8.571h43v2.858zm0-8.571V0h43v2.858z","className":"burger"}));
}

Menu.defaultProps = {"width":"43","height":"20"};

module.exports = Menu;

Menu.default = Menu;
